/**
 * 请求配置文件
 * 用于初始化请求管理器的白名单和其他配置
 */
import { setWhiteList } from './requestManager';

const DEFAULT_WHITE_LIST = ['auth/currentUserInfo'];

/**
 * 初始化请求配置
 */
const initRequestConfig = () => {
  setWhiteList(DEFAULT_WHITE_LIST);
};

export default initRequestConfig; 